/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopFilters_itemSearch = {
    readonly filters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly displayName: string | null;
            readonly urlLabel: string | null;
            readonly count: number | null;
            readonly code: string | null;
            readonly linkReference: string | null;
            readonly linkable: boolean | null;
            readonly hexCode: string | null;
            readonly stats: ReadonlyArray<{
                readonly key: string | null;
                readonly values: string | null;
            } | null> | null;
        } | null> | null;
        readonly totalCount: number | null;
        readonly localizedFilterName: string | null;
        readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterCategory_filters" | "SbRespRefineMenuFilterDimensions_filters" | "SbSharedRefineMenuFilterRingSize_filters">;
    } | null> | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterPrice_itemSearch" | "SbSharedRefineMenuFilterStone_itemSearch" | "SbSharedRefineMenuFilterMetal_itemSearch" | "SbSharedRefineMenuFilterColor_itemSearch" | "SbSharedRefineMenuFilterStyle_itemSearch" | "SbSharedRefineMenuFilterOrigin_itemSearch" | "SbSharedRefineMenuFilterPeriod_itemSearch" | "SbRespRefineMenuFilterCategory_itemSearch" | "SbRespRefineMenuFilterStoneCut_itemSearch" | "SbSharedRefineMenuFilterCreator_itemSearch" | "SbSharedRefineMenuFilterMaterial_itemSearch" | "SbRespRefineMenuFilterDeliveryOptions_itemSearch" | "SbSharedRefineMenuFilterItemType_itemSearch" | "SbSharedRefineMenuFilterJewelryType_itemSearch" | "SbRespRefineMenuFilterDimensions_itemSearch" | "SbRespRefineMenuFilterCaratWeight_itemSearch" | "SbSharedRefineMenuFilterAvailability_itemSearch" | "SbSharedRefineMenuFilterMatchingSets_itemSearch" | "SbSharedRefineMenuFilterGender_itemSearch" | "SbSharedRefineMenuFilterFraming_itemSearch" | "SbSharedRefineMenuFilterRingSize_itemSearch" | "SbSharedRefineMenuFilterArtOrientation_itemSearch">;
    readonly " $refType": "SbRespRefineTopFilters_itemSearch";
};
export type SbRespRefineTopFilters_itemSearch$data = SbRespRefineTopFilters_itemSearch;
export type SbRespRefineTopFilters_itemSearch$key = {
    readonly " $data"?: SbRespRefineTopFilters_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineTopFilters_itemSearch">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineTopFilters_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseFilter",
      "kind": "LinkedField",
      "name": "filters",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseFilterValue",
          "kind": "LinkedField",
          "name": "values",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hexCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "stats",
              "kind": "LinkedField",
              "name": "stats",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "values",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "localizedFilterName",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespRefineMenuFilterCategory_filters"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespRefineMenuFilterDimensions_filters"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedRefineMenuFilterRingSize_filters"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStone_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMetal_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterColor_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStyle_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterOrigin_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterPeriod_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterCategory_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterStoneCut_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterCreator_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMaterial_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDeliveryOptions_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterItemType_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterJewelryType_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterCaratWeight_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterAvailability_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMatchingSets_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterGender_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterFraming_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterRingSize_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterArtOrientation_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
})();
(node as any).hash = '79814fb4bf05e70d1ad9836618939ce0';
export default node;
